export { default } from '@components/HorizontalScroll/HorizontalScroll'
